import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { GateAddressItemMaintenanceDto } from './GateAddressItemMaintenanceDto';
import { GateAddressListMaintenanceDto } from './GateAddressListMaintenanceDto';

@Injectable()
export class GateAddressSubMaintenanceController extends BaseSubMaintenanceController<GateAddressListMaintenanceDto, GateAddressItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "gate/address");
    }

    public getResourceRoot(): string {
        return "GATE.ADDRESS";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/dataandparameters/gate/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}